import { useState, useEffect } from "react";
import { ScreenSize } from "@arcteryx/components-typography";

export const useDetectMobile = (forceClick) => {
  const [width, setWidth] = useState(null);

  useEffect(() => {
    setWidth(window.innerWidth);
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  if (forceClick) {
    return true;
  }

  return width !== null && width <= ScreenSize?.lg; // 992
};
